import AnimatedText from 'react-animated-text-content';
import { Col, Container, Row } from 'react-bootstrap';
import DiscordImg from '../../assets/images/discord.svg';
import EmailImg from '../../assets/images/emailw.svg';
import InstaImg from '../../assets/images/insta.svg';
import TwitterImg from '../../assets/images/twitter.svg';
import Footer from '../footer/Footer';
import './contactus.css';

const ContactUs = () => {
  const contactContent = (
    <>
      <Container fluid className='contactContainer '>
        <Container className='contact-inner-container'>
          <Row>
            <Col>
              <h1 className='contact__h1 '>
                <AnimatedText
                  type='chars' // animate words or chars
                  animation={{
                    x: '200px',
                    y: '-20px',
                    scale: 1.1,
                    ease: 'ease-in-out',
                  }}
                  animationType='throw'
                  interval={0.09}
                  duration={1}
                  tag='p'
                  className='animated-paragraph'
                  includeWhiteSpaces
                  threshold={0.9}
                  rootMargin='20%'
                >
                  CONTACT US
                </AnimatedText>
              </h1>
              <p className='contact__p1__top'>
                Are you ready to Save the World?
              </p>
              <p className='contact__p1'>
                Follow us on social media to stay updated with our project!{' '}
              </p>
            </Col>
          </Row>
          <Row className='mobi__row'>
            <Col>
              <div>
                {' '}
                <span className='span__box'>
                  <a
                    href='https://www.instagram.com/kuteekitty_nft'
                    rel='noreferrer'
                    target='_blank'
                  >
                    <img
                      src={InstaImg}
                      alt='instagram'
                      width={32}
                      className='social__icon'
                    />
                  </a>
                </span>
                <span className='span__box'>
                  <a
                    href='http://twitter.com/KuteeKitty_nft'
                    rel='noreferrer'
                    target='_blank'
                  >
                    <img
                      src={TwitterImg}
                      alt='instagram'
                      width={32}
                      className='social__icon'
                    />
                  </a>
                </span>
                <span className='span__box'>
                  <a
                    href='https://discord.gg/hj9Ug5Ag4z'
                    rel='noreferrer'
                    target='_blank'
                  >
                    <img
                      src={DiscordImg}
                      alt='instagram'
                      width={32}
                      className='social__icon'
                    />
                  </a>
                </span>
                {/* <span className='span__box'>
                  <a
                    href='http://opensea.io/collection/kutee-kitty'
                    rel='noreferrer'
                    target='_blank'
                  >
                    <img
                      src={OpenseaImg}
                      alt='instagram'
                      width={32}
                      className='social__icon'
                    />
                  </a>
                </span> */}

                
                <span className='span__box'>
                  <a href='mailto:info@kuteekitty.com'>
                    <img
                      src={EmailImg}
                      alt='instagram'
                      width={32}
                      className='social__icon'
                    />
                  </a>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </>
  );

  return <div>{contactContent}</div>;
};

export default ContactUs;
